const VARIANTS_ENUMS = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
  SECONDARY_INVERTED: "secondary-inverted",
  TERTIARY: "tertiary",
  PLAIN: "plain",
  PLAIN_INVERTED: "plain-inverted",
  DESTRUCTIVE: "destructive",
  DESTRUCTIVE_PLAIN: "destructive-plain"
};
const VARIANT_ICON_COLOR_MAP = {
  primary: "inverted",
  secondary: "default",
  "secondary-inverted": "inverted",
  tertiary: "primary-default",
  plain: "default",
  "plain-inverted": "inverted",
  destructive: "inverted",
  "destructive-plain": "error-default"
};
const SIZES_ENUMS = {
  XS: "xs",
  SM: "sm",
  MD: "md",
  LG: "lg"
};
export {
  SIZES_ENUMS,
  VARIANTS_ENUMS,
  VARIANT_ICON_COLOR_MAP
};
//# sourceMappingURL=constants.mjs.map
